import type { LucideIcon } from "lucide-react";
import * as LucideIcons from "lucide-react";
import type { IconKey } from "@/types/sections";

type IconRegistry = {
  components: Record<string, LucideIcon>;
  fallback: LucideIcon;
};

let registry: IconRegistry | null = null;

const ensureRegistry = (): IconRegistry => {
  if (registry) return registry;

  const source = (LucideIcons ?? {}) as Record<string, unknown>;
  const entries = Object.entries(source).filter(([name, component]) => {
    if (!/^[A-Z]/.test(name)) return false;
    const type = typeof component;
    return type === "function" || (type === "object" && component !== null);
  }) as [string, LucideIcon][];

  const components = Object.fromEntries(entries) as Record<string, LucideIcon>;
  const fallback =
    components["Gem"] ||
    (LucideIcons.Gem as LucideIcon | undefined) ||
    (() => null);

  registry = { components, fallback };
  return registry;
};

export const resolveIcon = (key?: IconKey, fallback?: LucideIcon) => {
  const { components, fallback: defaultIcon } = ensureRegistry();
  if (key && components[key]) {
    return components[key];
  }
  return fallback ?? defaultIcon;
};
